*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.signet-month-year-picker-container {
  position: relative;
  font-family: 'Lato';
  font-weight: normal;

  .input-container {
    display: flex;
    align-items: center;
    border: 1px solid var(--gray-300);
    width: fit-content;
    padding: 6px 12px;
    border-radius: 5px;
    width: 100%;

    .input {
      background-color: transparent;
      outline: none;
      border: 0;
      flex: 1;
    }

    .input[type='number']::-webkit-inner-spin-button,
    .input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }

    .material-icons {
      margin-top: 2px;
      cursor: pointer;
      color: var(--gray-500);
    }
  }

  .selected-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 85%;
    height: 100px;
    background-color: var(--primary-main);
    z-index: 99999;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 20px;

    .month,
    .year {
      font-weight: normal;
      color: var(--pure-white);
      margin-bottom: 0 !important;
    }

    .month {
      font-size: 24px;
    }
  }

  .year-picker {
    background-color: var(--pure-white);
    padding: 0 20px;
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    position: absolute;
    top: 100px;
    left: 0;
    width: 85%;
    z-index: 99999;

    .year-container {
      max-height: 250px;
      display: flex;
      flex-direction: column-reverse;
      gap: 20px;
      overflow: scroll;
      scroll-behavior: smooth;
      -ms-overflow-style: none;
      scrollbar-width: none;

      button {
        font-size: 16px;
        color: var(--gray-600);
        font-weight: normal;
        background: transparent;
        outline: 0;
        border: 0;
      }

      .selected-year {
        font-size: 20px !important;
        font-weight: bold;
        color: var(--primary-main);
        place-self: center;
      }
    }

    .year-container::-webkit-scrollbar {
      display: none;
    }
  }

  .month-picker {
    background-color: var(--pure-white);
    padding: 20px;
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    position: absolute;
    top: 100px;
    left: 0;
    width: 85%;
    z-index: 99999;

    .month-container {
      max-height: 250px;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 20px;

      button {
        font-size: 16px;
        color: var(--gray-600);
        font-weight: normal;
        background: transparent;
        outline: 0;
        border: 0;
      }

      .selected-month {
        font-size: 20px !important;
        font-weight: bold;
        color: var(--primary-main);
      }
    }
  }
}
